import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Field,
  reduxForm,
  reset,
  submit,
  stopSubmit,
  setSubmitFailed,
} from "redux-form";
import _ from "lodash";
import { Modal } from "react-bootstrap";
import { StripeProvider, Elements } from "react-stripe-elements";
import { COMMON_FAIL_MESSAGE, STRIPE_PUBLISHABLE_KEY } from "Constants";
import {
  openClientCardInfoModal,
  createCustomerStripeToken,
  addStripeToken,
  updateCustomerStripeToken,
} from "TicketAction";
import { showError, showSuccess } from "ReduxErrorBar";
import AddPayfastForm from "../payfast/add-payfast-form";
import LocaleStrings from "Languages";

class AddCCInfo extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  componentDidMount() {}

  closeModal = () => {
    this.props.reset();
    this.props.openClientCardInfoModal({ showModal: false });
  };

  tokenReceived = (token, error) => {
    let { session, SettingData, showModal } = this.props;

    if (!error) {
      if (showModal && showModal.update && showModal.update == "card") {
        // update client credit card info
        let updata = {
          stripecustomerid: SettingData.resource[0].stripecustomerid,
          tokenid: token.id,
        };

        this.props.updateCustomerStripeToken(session, updata, (response) => {
          if (response.success) {
            let cardid = response.cardid;
            let data = {
              id: SettingData.resource[0].id,
              stripecustomercardid: cardid,
            };

            this.props.addStripeToken(session, data, (res) => {
              // this.setState({loading: false});

              if (res.success == 1) {
                this.props.showSuccess(
                  LocaleStrings.tickets_payfast_form_card_update_success
                );
                this.closeModal();
              } else {
                this.props.showError(COMMON_FAIL_MESSAGE);
              }
            });
          } else {
            // this.setState({loading: false});
            this.props.showError(LocaleStrings.tickets_payfast_form_error);
          }
        });
      } else {
        // add client credit card info
        let values = {
          clientemail: session.emailid,
          tokenid: token.id,
          cardid: token.card.id,
        };

        this.props.createCustomerStripeToken(session, values, (response) => {
          if (response.success) {
            let custid = response.custid;
            let data = {
              id: SettingData.resource[0].id,
              stripecustomerid: custid,
              stripecustomercardid: values.cardid,
            };

            this.props.addStripeToken(session, data, (res) => {
              // this.setState({loading: false});
              if (res.success == 1) {
                this.props.showSuccess(
                  LocaleStrings.tickets_payfast_form_success
                );
                this.closeModal();
              } else {
                this.props.showError(COMMON_FAIL_MESSAGE);
              }
            });
          } else {
            // this.setState({loading: false});
            this.props.showError(LocaleStrings.tickets_payfast_form_error);
          }
        });
      }
    } else {
      this.props.showError(error.message);
    }
  };

  render() {
    var { showModal, editMode } = this.props;

    return (
      <div>
        <Modal
          className="modal-container"
          show={showModal.showModal === true ? true : false}
          animation={true}
          keyboard={false}
          backdrop="static"
          dialogClassName="cardInfoModal"
        >
          <Modal.Header>
            <div className="import-modal-title">
              {editMode
                ? LocaleStrings.tickets_payfast_modal_update_title
                : `${LocaleStrings.tickets_payfast_modal_add_title}`}
            </div>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={() => this.closeModal()}
            >
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
          </Modal.Header>
          <Modal.Body>
            <div>
              <StripeProvider apiKey={STRIPE_PUBLISHABLE_KEY}>
                <Elements>
                  <AddPayfastForm
                    {...this.props}
                    onTokenReceived={this.tokenReceived}
                    onCloseModal={this.closeModal}
                  />
                </Elements>
              </StripeProvider>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var toEdit = false;
  if (
    state.clientCardInfoModal &&
    state.clientCardInfoModal.update &&
    state.clientCardInfoModal.update != ""
  ) {
    toEdit = true;
  }

  return {
    session: state.session,
    showModal: state.clientCardInfoModal,
    editMode: toEdit,
    SettingData: state.SettingData,
  };
}

function validate(values, ownProps) {
  // var errors = {};
  // return errors;
}

export default connect(mapStateToProps, {
  openClientCardInfoModal,
  createCustomerStripeToken,
  addStripeToken,
  updateCustomerStripeToken,
  showError,
  showSuccess,
})(
  reduxForm({
    validate,
    form: "CCInfoForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(AddCCInfo)
);
